import React, { ReactElement } from "react";

import { TLayout } from "core/models/routes.model";
import { MainLayout } from "./MainLayout";

export const layouts: Record<TLayout, (page: ReactElement) => ReactElement> = {
  main: (page) => <MainLayout>{page}</MainLayout>,

  blank: (page) => page,
};
